<template>
  <div class="sortable-item">
    <div class="toggle-edit pull-right nowrap ml-1">
      <slot name="buttons"></slot>

      <c-button-link
          v-if="hasEditListener"
          type="button"
          theme="primary"
          size="sm"
          icon="fa-duotone fa-pen-to-square"
          @click="$emit('edit')"
      >
        <span class="hidden-xs hidden-sm">Edit</span>
      </c-button-link>

      <c-button-link
          v-if="!hideRemoveButton && hasRemoveListener"
          type="button"
          theme="danger"
          size="sm"
          icon="fa-duotone fa-trash-can"
          @click="$emit('remove')"
      >
        <span class="hidden-xs hidden-sm">Remove</span>
      </c-button-link>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props:['hideRemoveButton'],
  computed: {
    hasEditListener() {
      return this.$listeners && this.$listeners.edit
    },
    hasRemoveListener() {
      return this.$listeners && this.$listeners.remove
    }
  }
}
</script>

<style scoped>
.sortable-item {
  border: 1px solid #eee;
  border-radius: 4px;
  margin-bottom: 1em;
  padding: 1em 1.5em;
}
</style>
